if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      /*
      * 拡張
      */
      order() {
        return (function() {

          const modal = `<div class="order-modal-overlay" style="display:block"></div>
                        <div class="order-modal-dialog">
                          <div class="order-modal-wrapper">
                            <div class="order-modal-content">
                              <div class="order-modal-header">
                                <span class="order-modal-title">ご注意ください</span>
                                <span class="order-modal-close" data-wl-js-modal-close>×</span>
                              </div>
                              <div class="order-modal-body">
                                <p>※こちらは取寄商品です。発送までに3営業日以上かかる場合がございます。<br>
                                  <font color="#CA323D">※ 貴和クリスタル、チェコビーズは納期が数ヶ月先になる場合がございます。納期によりご注文をご検討される場合は、ご注文前に<a href="https://kiwaseisakujo.myshopify.com/pages/contact-onlinestore"><u>お問合せフォーム</u></a>よりお問い合わせください。</font><br>※「取寄商品」は通常商品と同時に注文する事ができません。<br>※「取寄商品」と通常商品が同じカート内にあるとご注文手続きへ進めません。<br>※「取寄商品」と通常商品の同梱はいたしかねます。<br>※「取寄商品」のキャンセルはご遠慮いただいております。<br>※商品によっては納期が変動する場合がございます。<br>※メーカー廃盤により取り寄せができない場合がございます。<br>※「取寄商品」を複数ご注文いただいた場合、全ての商品が揃い次第発送いたします。<br>※クレジットカード決済や後払いなど、代金引換以外の決済方法は、ご注文完了の時点で決済処理いたします。発送までにお時間のかかる商品に関しては前払いになります。<br>あらかじめご了承ください。</p>
                              </div>
                              <div class="order-modal-footer">
                                <input type="button" name="btnAgree" class="btn btn-primary" value="同意する"> 
                                <input type="button" name="btnNotAgree" class="btn btn-secondary" value="同意しない">
                              </div>
                            </div>
                          </div>
                        </div>`
        
          const wlOrderItem = {
        
            body: document.querySelector( 'body' ),
            form: '',
            scroll: 0,

            // 同意確認
            agreeCheckEventListen() {
              const self = this;

              self.showModal();
              return new Promise( (resolve, reject ) => {
                document.querySelectorAll('.order-modal-footer input[type="button"]').forEach(button => {
                  button.addEventListener('click', (e) => {
                    const agree = e.target.attributes.value.value;
                    if (agree == '同意する') {
                      self.hideModal();
                      self.releaseFixedWindow();
                      resolve();
                    } else {
                      self.hideModal();
                      self.releaseFixedWindow();
                      reject(new Error('同意しないボタンがクリックされました'));
                    }
                  });
                });
              });
            },
        
            // 画面固定
            fixedWindow() {
              const scrollTop = document.documentElement.scrollTop;
        
              this.scroll = scrollTop;
              this.body.style.position = 'fixed';
              this.body.style.top = `-${scrollTop}px`;
              this.body.style.width = '100%';
              this.body.style.height = '100vh';
            },
        
            // 画面固定解除
            releaseFixedWindow() {
              this.body.style.position = 'static';
              this.body.style.width = 'auto';
              this.body.style.height = 'auto';
              window.scrollTo(0,  this.scroll);
            },
        
            // modal表示
            showModal() {
              const container = document.createElement('div');
        
              container.className = 'order-modal-container';
              container.innerHTML = modal;
              document.body.appendChild(container);
              this.fixedWindow();
              this.modalCloseButton();
            },
        
            // modal非表示
            hideModal() {
              document.querySelector('.order-modal-container').remove();
            },
        
            modalCloseButton() {
              document.querySelector( '[data-wl-js-modal-close]' ).addEventListener( 'click',() => {
                this.hideModal();
                this.releaseFixedWindow();
              });
            }
          };
        
          return wlOrderItem;
        
        })();
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        const test = this.order();
        if ( this.form.dataset.order === 'true' ) await test.agreeCheckEventListen();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            //this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
